import React, { useState, useEffect, useRef } from 'react';
import ScheduleList from '../components/scheduleList'
import moment from 'moment-timezone';
import { useLocation } from 'react-router-dom';

const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  };

const PlayList = ({...props}) =>
{   
    const [seconds, setSeconds] = useState(0);
    const [isActive, setIsActive] = useState(true);
    const [visibleItems, setVisibleItems] = useState([]);
    const [currentItem, setCurrentItem] = useState({unique:0});
    const query = useQuery();
    

    const filterVisibleItems = () =>{
        let newItems = [];
        let room = query.get('room');

        const now = moment().tz('America/New_York').format('YYYY-MM-DD HH:mm:ss');
        if (props.items.length > 0) {
            
            let current = null;
            let lastItem = null;
            for (const item of props.items) {
                
                const isFutureItem = moment(item.start).subtract(item.buffer,'second').isAfter(now);

                if(isFutureItem)
                {
                    newItems.push(item);
                }
                else if(room == item.unique && moment(item.start).subtract(item.buffer,'second').subtract(1,'second').isBefore(now) && moment(item.end).isAfter(now))
                {
                    current = item;
                }
                else if(item.registered && moment(item.end).isAfter(now) && current == null)
                {   
                    current = item;
                }
                else if(moment(item.end).isAfter(now))
                {
                    lastItem = item;
                }
            }
            if(current == null ) 
            {
                current = lastItem;
            }
            if((current == null && newItems.length == 0) || (newItems.length == 0 && moment(current.end).isBefore(now))   ){
                setIsActive(false);
                props.onPlaylistEnd();
                return;
            }        
            if(current && currentItem.unique != current.unique) {
                setCurrentItem(current);
                props.onItemReady(current);
            }
        }else{
            setIsActive(false);
            props.onPlaylistEnd();
        }     
        setVisibleItems(newItems);
        return newItems;
    }

    //Update Visible Items
    useEffect(() => {
        let interval = null;
        if (isActive) {
            interval = setInterval(() => {
                setSeconds(seconds => seconds + 1);
                filterVisibleItems();
            }, 1000);
        } else if (!isActive && seconds !== 0) {
            clearInterval(interval);
        }
        return () => clearInterval(interval);
    }, [props.items, seconds, isActive, currentItem]);

    return (
        
        <div className="flex flex-wrap">
        {visibleItems.length > 0 && (    
            <>
            <h3 className="text-xl lg:text-3xl font-bold text-gray-700 pt-8 w-full">Upcoming</h3>
                <div className="w-full">
                    <ScheduleList 
                        items={visibleItems} 
                        onButtonClick={props.onButtonClick} 
                        hideDate={true}
                        hideButtons={true}
                    />
                </div>
              
                </>  )}
        </div>
        
    )
}

export default PlayList;